import { render, staticRenderFns } from "./LeilaoCrm.vue?vue&type=template&id=1da2a84c"
import script from "./LeilaoCrm.vue?vue&type=script&lang=js"
export * from "./LeilaoCrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports